<template>
    <svg class="icon" aria-hidden="true">
        <use :fill="color ? color : '#90939A'" :xlink:href="'#' + name"></use>
    </svg>
</template>

<script>
export default {
    name: "Svgs",
    props: ["name", "color"],
};
</script>

<style scoped>
.icon {
    width: 0.19rem;
    height: 0.19rem;
}
</style>